import find from "lodash/find";
import isNull from "lodash/isNull";
import { useEffect } from "react";

import useStripePaymentMethodStore from "../store";

const useSetupDefaultPaymentMethodsProvider = () => {
  const {
    paymentMethods,
    setSelectedPaymentMethod,
    setDefaultPaymentMethod,
    existingSubscription,
    existingCustomer,
  } = useStripePaymentMethodStore();

  useEffect(() => {
    let defaultPaymentMethodID = null as null | string;

    // set payment method based on existing subscription
    if (
      existingSubscription !== undefined &&
      !isNull(existingSubscription) &&
      existingSubscription.default_payment_method !== undefined &&
      !isNull(existingSubscription.default_payment_method)
    ) {
      defaultPaymentMethodID =
        existingSubscription.default_payment_method as string;
      existingSubscription.default_payment_method as string;
    } else if (
      // set payment method based on existing customer data
      existingCustomer !== undefined &&
      !isNull(existingCustomer) &&
      existingCustomer.invoice_settings !== undefined &&
      !isNull(existingCustomer.invoice_settings) &&
      existingCustomer.invoice_settings.default_payment_method !== undefined &&
      !isNull(existingCustomer.invoice_settings.default_payment_method)
    ) {
      defaultPaymentMethodID =
        typeof existingCustomer.invoice_settings.default_payment_method ===
        "string"
          ? (existingCustomer.invoice_settings.default_payment_method as string)
          : existingCustomer.invoice_settings.default_payment_method.id;
    }
    if (
      defaultPaymentMethodID !== undefined &&
      !isNull(defaultPaymentMethodID)
    ) {
      // set default payment if found
      setDefaultPaymentMethod(defaultPaymentMethodID);

      if (
        paymentMethods !== undefined &&
        !isNull(paymentMethods) &&
        paymentMethods.length > 0
      ) {
        setSelectedPaymentMethod(
          find(
            paymentMethods,
            (method) => method.id === defaultPaymentMethodID
          ) ||
            paymentMethods[0] ||
            null
        );
      }
    } else {
      if (
        paymentMethods !== undefined &&
        !isNull(paymentMethods) &&
        paymentMethods.length > 0
      ) {
        setSelectedPaymentMethod(paymentMethods[0] || null);
      }
    }
  }, [paymentMethods, existingSubscription, existingCustomer]);
};

export default useSetupDefaultPaymentMethodsProvider;
